module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-W31JM906VZ"],"pluginConfig":{"head":true,"anonymize_ip":true}},
    }]
